import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const init = () => {
    // Prevent multiple initializations
    if (window.bookComponentInitialized) {
        return;
    }
    
    // Wait for both DOM and data to be ready
    function initializeWhenReady() {
        const $component = $('.js-book-details');
        if (!$component.length) {
            return;
        }
        
        // Load data from PCI-compliant hidden elements
        loadBookDataFromDOM();
        
        // Check if window.bookData is now available
        if (!window.bookData) {
            setTimeout(initializeWhenReady, 100);
            return;
        }
        
        // Mark as initialized to prevent multiple calls
        window.bookComponentInitialized = true;

        // Initialize all book page functionality
        initRetailerTracking();
        initRelatedBooks();
        initMediaGallery();
        initABTesting();
        // Note: Look inside functionality is handled by book-details.js component
    }

    // PCI Compliant data loading from hidden DOM elements
    function loadBookDataFromDOM() {
        // Extract extra media data
        const extraMediaElement = document.getElementById('extra-media-data');
        if (extraMediaElement && extraMediaElement.textContent && extraMediaElement.textContent.trim() !== '') {
            try {
                window.extraMedia = JSON.parse(extraMediaElement.textContent);
            } catch (e) {
                console.warn('Error parsing extra media data, using empty array:', e.message);
                window.extraMedia = [];
            }
        } else {
            window.extraMedia = [];
        }
        
        // Extract book data from data attributes
        const bookDataElement = document.getElementById('book-data');
        if (bookDataElement) {
            window.bookData = {
                id: parseInt(bookDataElement.dataset.id) || 0,
                name: bookDataElement.dataset.name || '',
                isbn: bookDataElement.dataset.isbn || '',
                price: bookDataElement.dataset.price || '',
                BIC: bookDataElement.dataset.bic || 'No BIC Found',
                subjects: []
            };
            
            // Parse subjects JSON
            try {
                if (bookDataElement.dataset.subjects && bookDataElement.dataset.subjects.trim() !== '') {
                    window.bookData.subjects = JSON.parse(bookDataElement.dataset.subjects);
                } else {
                    window.bookData.subjects = ["No Subjects Found"];
                }
            } catch (e) {
                console.warn('Error parsing subjects data, using default:', e.message);
                window.bookData.subjects = ["No Subjects Found"];
            }
        } else {
            window.bookData = {};
        }
        
        // Extract look inside data
        const lookInsideElement = document.getElementById('look-inside-data');
        if (lookInsideElement) {
            window.lookInsideProps = {
                query: lookInsideElement.dataset.query || '',
                isHidden: lookInsideElement.dataset.isHidden === 'true',
                isbns: lookInsideElement.dataset.isbns || ''
            };
        } else {
            window.lookInsideProps = {};
        }
        
    }

    // Start initialization when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeWhenReady);
    } else {
        // DOM is already ready
        initializeWhenReady();
    }

    // Retailer click tracking
    function initRetailerTracking() {
        const retailerLinks = document.querySelectorAll('.c-retailers__retailer');

        if (retailerLinks.length !== 0) {
            retailerLinks.forEach(link => {
                link.addEventListener('click', logRetailerClick);
            });

            function logRetailerClick(e) {
                const retailerNameElement = e.currentTarget.querySelector('.c-retailers__retailer-name');
                const retailerName = retailerNameElement ? retailerNameElement.textContent.trim() : 'Unknown';
                const retailerLink = e.currentTarget.href;

                const coverImageElement = document.querySelector('.c-book-details__cover-img');
                const BIC = window.bookData?.BIC || "No BIC Found";
                const subjects = window.bookData?.subjects || ["No Subjects Found"];

                const logEvent = {
                    ProductName: window.bookData?.name || '',
                    ProductID: BIC,
                    SKU: window.bookData?.isbn || '',
                    Categories: subjects,
                    ImageURL: coverImageElement ? coverImageElement.src : '',
                    URL: document.location.href,
                    Brand: retailerName,
                    Price: window.bookData?.price || '',
                    CompareAtPrice: ''
                }

                if (window.klaviyo) {
                    klaviyo.track('Viewed Product', logEvent);
                }
            }    
        }
    }

    // Related books lazy loading
    function initRelatedBooks() {
        // Check if related books section exists (now rendered server-side via partial)
        let $relatedBooks = $('#related-books');
        if (!$relatedBooks.length) {
            return;
        }
        
        
        // Initialize image loading for any existing content first
        initRelatedBooksImageLoading();
        
        // Load related books immediately instead of waiting for scroll
        // since the section is now positioned earlier in the page
        function loadRelatedBooks() {
            if($relatedBooks.attr('loaded')) {
                return;
            }
            
            $relatedBooks.attr('loaded', true);
            const bookId = $relatedBooks.data('id');
            
            
            if (!bookId) {
                console.warn('No book ID found in related books section');
                return;
            }
                    
            $.ajax({
                url: "../api/books/" + bookId + "/related",
                success: function (response) {
                    var len = response.length;

                    for (var i = 0; i < len; i++) {
                        var name = response[i]['name'];
                        var image = response[i]['thumbnail'];
                        var link = response[i]['link'];
                        var byline = response[i]['byline'];

                        var bookContent = '<div class="c-swiper__slide"><div class="c-book-block__slide"><div class="c-book-block__thumb">';
                            bookContent += '<a tabindex="-1" href="'+ link +'">';               
                            bookContent += '<img class="" alt="" src="https://cdn2.penguin.com.au/covers/400/'+ image +'" />';
                            bookContent += '<div class="c-swiper__penguin"></div>';
                            bookContent += '</a>';
                            bookContent += '</div>';
                            bookContent += '<div class="c-book-block__content">';
                            bookContent += '<a href="'+ link +'">';
                            bookContent += '<div class="c-book-block__title u-line-clamp" data-maxlines="3">'+ name +'</div>';
                            bookContent += '</a>';
                            if(byline && byline.length > 0) {
                                bookContent += '<div class="c-book-block__byline">';
                                bookContent += byline;
                                bookContent += '</div>';
                            }
                            bookContent += '</div>';
                            bookContent += '</div>';
                            bookContent += '</div>';
                        $("#related-books .c-swiper__wrap").append(bookContent);
                    }
                    
                    // Initialize swiper after content is loaded
                    initRelatedBooksSwiper();
                    
                    // Initialize image loading animation for dynamically loaded content
                    initRelatedBooksImageLoading();
                },
                error: function(xhr, status, error) {
                    console.error('Error loading related books:', error);
                    console.error('Status:', status);
                    console.error('Response:', xhr.responseText);
                    console.error('URL attempted:', "../api/books/" + bookId + "/related");
                }
            });
        }
        
        // Load immediately instead of waiting for scroll
        // Add a small delay to ensure DOM is fully ready
        setTimeout(loadRelatedBooks, 100);
        
        // Fallback: Also try loading on scroll in case immediate loading fails
        $(window).scroll(function() {
            if ($(window).scrollTop() + $(window).height() >= $relatedBooks.offset().top - 250) {
                loadRelatedBooks();
            }
        });
        
        // Initialize swiper for related books
        function initRelatedBooksSwiper() {
            const $relatedBooks = $('#related-books');
            if (!$relatedBooks.length) return;
            
            // Check if swiper already exists and destroy it
            if ($relatedBooks[0].swiper) {
                $relatedBooks[0].swiper.destroy(true, true);
            }
            
            // Initialize new swiper
            const swiper = new Swiper($relatedBooks.find('.c-swiper__container')[0], {
                modules: [Navigation, Pagination],
                wrapperClass: 'c-swiper__wrap',
                slideClass: 'c-swiper__slide',
                slideActiveClass: 'is-active',
                slideDuplicateActiveClass: 'is-duplicate-active',
                slideVisibleClass: 'is-visible',
                slideDuplicateClass: 'is-duplicate',
                slideNextClass: 'is-next',
                slideDuplicateNextClass: 'is-duplicate-next',
                slidePrevClass: 'is-prev',
                slideDuplicatePrevClass: 'is-duplicate-prev',
                containerModifierClass: 'c-swiper__container--',
                
                slidesPerView: 'auto',
                spaceBetween: 0,
                watchSlidesProgress: true,
                allowTouchMove: true,
                
                // Navigation configuration
                navigation: {
                    nextEl: $relatedBooks.find('.js-swiper-next')[0],
                    prevEl: $relatedBooks.find('.js-swiper-prev')[0],
                    disabledClass: 'swiper-button-disabled',
                    hiddenClass: 'swiper-button-hidden',
                },
                
                // Events
                on: {
                    init: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                        PubSub.publish('text-clamp:run');
                    },
                    
                    slideChange: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    slideChangeTransitionStart: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    slideChangeTransitionEnd: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    reachBeginning: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    reachEnd: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    fromEdge: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    toEdge: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    resize: function () {
                        // Don't force slide to 0 on resize - let swiper maintain current position
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                    
                    update: function () {
                        updateRelatedBooksNavigationState(this, $relatedBooks);
                    },
                },
                
                init: false,
            });
            
            // Store swiper instance on the element
            $relatedBooks[0].swiper = swiper;
            
            // Initialize
            swiper.init();
            
            // Update navigation state after initialization
            setTimeout(() => {
                updateRelatedBooksNavigationState(swiper, $relatedBooks);
            }, 100);
        }
        
        // Update navigation state for related books
        function updateRelatedBooksNavigationState(swiper, $el) {
            const hasMoreSlides = swiper.slides.length > 1;
            
            // Update touch movement
            swiper.allowTouchMove = hasMoreSlides;
            
            // Update navigation visibility and state
            const $navContainer = $el.find('.c-title-bar__nav');
            if ($navContainer.length) {
                $navContainer.toggleClass('active', hasMoreSlides);
            }

            // Determine if navigation is possible in each direction
            const canSlidePrev = swiper.allowSlidePrev && !swiper.isBeginning;
            const canSlideNext = swiper.allowSlideNext && !swiper.isEnd;

            // Update navigation buttons
            if (swiper.navigation && swiper.navigation.nextEl) {
                const $nextBtn = $(swiper.navigation.nextEl);
                $nextBtn.prop('disabled', !canSlideNext);
                $nextBtn.toggleClass('swiper-button-disabled', !canSlideNext);
            }
            
            if (swiper.navigation && swiper.navigation.prevEl) {
                const $prevBtn = $(swiper.navigation.prevEl);
                $prevBtn.prop('disabled', !canSlidePrev);
                $prevBtn.toggleClass('swiper-button-disabled', !canSlidePrev);
            }
        }
        
        // Initialize image loading animation for related books
        function initRelatedBooksImageLoading() {
            const $relatedBooks = $('#related-books');
            if (!$relatedBooks.length) return;
            
            // Handle image loading with CLS prevention for dynamically loaded content
            const images = $relatedBooks.find('img');
            images.each(function() {
                const $img = $(this);
                const $container = $img.closest('.c-book-block__thumb');
                
                if ($img[0].complete) {
                    $img.addClass('loaded');
                    $container.addClass('image-loaded');
                } else {
                    $img.on('load', function() {
                        $img.addClass('loaded');
                        $container.addClass('image-loaded');
                    });
                    $img.on('error', function() {
                        // Still fade in on error to prevent infinite loading state
                        $img.addClass('loaded');
                        $container.addClass('image-loaded');
                    });
                }
            });
        }
    }

    // Media gallery initialization
    function initMediaGallery() {
        const largeGallery = document.querySelector('.large-gallery');
        const thumbnailGallery = document.querySelector('.thumbnail-gallery');

        if (largeGallery) {
            let mediaSwiper;
            mediaSwiper = new Swiper('.large-gallery', {
                modules: [Navigation],
                slidesPerView: 'auto',
                spaceBetween: 36,
                navigation: {
                    nextEl: '.large-controls-next',
                    prevEl: '.large-controls-prev',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 'auto',
                        spaceBetween: 28,
                    },
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 36,
                    },
                }
            });
        }

        if (thumbnailGallery) {
            let desktopSwiper, mobileSwiper;

            // Initialize Swiper instances
            function initializeSwipers() {
                const isMobile = window.innerWidth <= 1024;

                // Destroy existing Swipers if any
                if (desktopSwiper) desktopSwiper.destroy(true, true);
                if (mobileSwiper) mobileSwiper.destroy(true, true);

                // Function to update gallery navigation state
                function updateGalleryNavigationState(swiper) {
                    const canSlidePrev = swiper.allowSlidePrev && !swiper.isBeginning;
                    const canSlideNext = swiper.allowSlideNext && !swiper.isEnd;

                    // Update navigation buttons
                    if (swiper.navigation && swiper.navigation.nextEl) {
                        const $nextBtn = $(swiper.navigation.nextEl);
                        $nextBtn.prop('disabled', !canSlideNext);
                        $nextBtn.toggleClass('swiper-button-disabled', !canSlideNext);
                    }
                    
                    if (swiper.navigation && swiper.navigation.prevEl) {
                        const $prevBtn = $(swiper.navigation.prevEl);
                        $prevBtn.prop('disabled', !canSlidePrev);
                        $prevBtn.toggleClass('swiper-button-disabled', !canSlidePrev);
                    }
                }

                // Initialize for desktop
                if (!isMobile) {
                    desktopSwiper = new Swiper('.desktop-only .gallery-wrapper', {
                        modules: [Navigation],
                        slidesPerView: 'auto',
                        spaceBetween: 12,
                        navigation: {
                            nextEl: '.desktop-only .swiper-button-next',
                            prevEl: '.desktop-only .swiper-button-prev',
                        },
                        breakpoints: {
                            1024: {
                                slidesPerView: 'auto',
                                spaceBetween: 12,
                            },
                        },
                        on: {
                            init: function() {
                                setTimeout(() => updateGalleryNavigationState(this), 100);
                            },
                            slideChange: updateGalleryNavigationState,
                            reachBeginning: updateGalleryNavigationState,
                            reachEnd: updateGalleryNavigationState,
                            resize: updateGalleryNavigationState,
                            slideChangeTransitionStart: updateGalleryNavigationState,
                            slideChangeTransitionEnd: updateGalleryNavigationState,
                            fromEdge: updateGalleryNavigationState,
                            toEdge: updateGalleryNavigationState,
                            update: updateGalleryNavigationState
                        }
                    });
                } else {
                    // Initialize for mobile
                    mobileSwiper = new Swiper('.mobile-only .gallery-wrapper', {
                        modules: [Navigation],
                        slidesPerView: 'auto',
                        spaceBetween: 8,
                        navigation: {
                            nextEl: '.mobile-only .swiper-button-next',
                            prevEl: '.mobile-only .swiper-button-prev',
                        },
                        on: {
                            init: function() {
                                setTimeout(() => updateGalleryNavigationState(this), 100);
                            },
                            slideChange: updateGalleryNavigationState,
                            reachBeginning: updateGalleryNavigationState,
                            reachEnd: updateGalleryNavigationState,
                            resize: updateGalleryNavigationState,
                            slideChangeTransitionStart: updateGalleryNavigationState,
                            slideChangeTransitionEnd: updateGalleryNavigationState,
                            fromEdge: updateGalleryNavigationState,
                            toEdge: updateGalleryNavigationState,
                            update: updateGalleryNavigationState
                        }
                    });
                }
            }

            // Debounce function to limit resize event firing
            function debounce(func, wait) {
                let timeout;
                return function() {
                    clearTimeout(timeout);
                    timeout = setTimeout(func, wait);
                };
            }

            // Reinitialize Swipers on resize
            $(window).resize(debounce(function() {
                initializeSwipers();
            }, 250));  // 250ms debounce

            // Initial load
            window.setTimeout(function() {
                initializeSwipers();
            }, 250);

            // Debug function for gallery navigation
            window.testGalleryNavigation = function() {
                // Debug function for testing gallery navigation
                // This function can be used to inspect gallery swiper state in the console
            };
        }
    }

    // A/B Testing for media gallery
    function initABTesting() {
        if (!window.extraMedia || window.extraMedia.length === 0) {
            return;
        }

        // Assign user to a variation (A or B or C)
        function assignVariation() {
            if (window.location.href.includes('var_a')) {
                localStorage.setItem('penguin.abTestVariation', 'A');
                return 'A';
            } else if (window.location.href.includes('var_b')) {
                localStorage.setItem('penguin.abTestVariation', 'B');
                return 'B';
            } else if (window.location.href.includes('var_c')) {
                localStorage.setItem('penguin.abTestVariation', 'C');
                return 'C';
            } else {
                // Check if the user already has an assigned variation in localStorage
                let variation = localStorage.getItem('penguin.abTestVariation');
                
                if (!variation) {
                    // Randomly assign 'A' or 'B' or 'C' to the user
                    variation = Math.random() < 0.33 ? 'A' : Math.random() > 0.66 ? 'C' : 'B';
                    localStorage.setItem('penguin.abTestVariation', variation);
                    return variation;
                }
                return variation;
            }
        }

        // Load the appropriate variation
        function loadVariation(variation) {
            const body = document.querySelector('body');
            
            if (variation === 'A') {
                // Variation A: Thumbnail Media Gallery
                body.classList.add('variation-a');
            } else if (variation === 'B') {
                // Variation B: Large Media Gallery
                body.classList.add('variation-b');
            } else if (variation === 'C') {
                // Variation C: No Media Gallery
                body.classList.add('variation-c');
            }
        }

        // Run the A/B test logic
        const userVariation = assignVariation();
        loadVariation(userVariation);

        let userInteraction = false;

        const galleryImages = document.querySelectorAll('.gallery-item a');
        const retailers = document.querySelectorAll('.c-retailers__retailer');

        galleryImages.forEach(image => {
            image.addEventListener('click', function() {
                if (!userInteraction) {
                    logGalleryInteraction(userVariation);
                    userInteraction = true;
                }
            });
        });

        retailers.forEach(retailer => {
            retailer.addEventListener('click', function() {
                logRetailerInteraction(userVariation, retailer.querySelector('.c-retailers__retailer-name').textContent);
            });
        });

        const dataLayer = window.dataLayer || [];

        const logGalleryInteraction = (variation) => {
            dataLayer.push({
                event: 'Image Gallery Interaction',
                url: window.location.href,
                book: window.bookData?.name || '',
                isbn: window.bookData?.isbn || '',
                device: window.innerWidth <= 1024 ? 'Mobile' : 'Desktop',
                gallery_variation: variation
            })
        }

        const logRetailerInteraction = (variation, retailer) => {
            dataLayer.push({
                event: 'Retailer Interaction',
                url: window.location.href,
                book: window.bookData?.name || '',
                isbn: window.bookData?.isbn || '',
                device: window.innerWidth <= 1024 ? 'Mobile' : 'Desktop',
                retailer: retailer,
                gallery_variation: variation
            })
        }
    }
}

export default init;